import { render, staticRenderFns } from "./btn-doc-download.vue?vue&type=template&id=2fc57480&scoped=true&"
import script from "./btn-doc-download.vue?vue&type=script&lang=js&"
export * from "./btn-doc-download.vue?vue&type=script&lang=js&"
import style0 from "./btn-doc-download.vue?vue&type=style&index=0&id=2fc57480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc57480",
  null
  
)

export default component.exports